import { Exclude, Expose, Type } from 'class-transformer';

import { ApiProperty } from '@nestjs/swagger';
import { JobWarrantySheetInterface } from '../interfaces/job-warranty-sheet.interface';
import { BuilderInterface } from 'src/modules/builder/interfaces/builder.interface';
import { JobPhaseInterface } from 'src/modules/job-phase/interfaces/job-phase.interface';
import { JobInterface } from 'src/modules/job/interfaces/job.interface';
import { RegionInterface } from 'src/modules/region/interfaces/region.interface';
import { PhaseTypeEnum } from '../../phase/enums/phase-type.enum';

@Exclude()
export class JobWarrantySheetDto implements JobWarrantySheetInterface {
  //
  // Job fields
  //
  @ApiProperty({
    title: 'Job ID (synonym for React Admin only)',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Job ID',
  })
  @Expose()
  jobId!: string;

  @ApiProperty({
    title: 'Job Lot',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job Block',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Job current Job Phase ID',
  })
  @Expose()
  jobPhaseId!: string;

  @ApiProperty({
    type: 'string',
    title: 'Address',
  })
  @Expose()
  address1!: string | null;

  //
  // Phase fields
  //

  @ApiProperty({
    type: 'string',
    format: 'uuid',
    title: 'Phase ID',
  })
  @Expose()
  currentPhaseId!: string;

  @ApiProperty({
    type: 'string',
    title: 'Phase Name',
  })
  @Expose()
  currentPhaseName!: string;

  //
  // Subdivision fields
  //

  @ApiProperty({
    title: 'Subdivision ID',
  })
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    title: 'Subdivision Name',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Supervisor User ID',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'Supervisor First Name',
  })
  @Expose()
  supervisorFirstName!: string;

  @ApiProperty({
    title: 'Supervisor Last Name',
  })
  @Expose()
  supervisorLastName!: string;

  //
  // Region fields
  //

  @ApiProperty({
    title: 'Region ID',
  })
  @Expose()
  regionId = '';

  //
  // Builder fields
  //

  @ApiProperty({
    title: 'Builder Id',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  //
  // Board purchase fields
  //

  @ApiProperty({
    title: 'Total Payable Boards',
  })
  @Expose()
  payableBoardsTotal!: number | null;

  @ApiProperty({
    title: 'Total Supervisor cOunt',
  })
  @Expose()
  payableBoardsReceiptTotal!: number | null;

  //
  // Bump1 Phase fields
  //

  @ApiProperty({
    title: 'Bump1 Contractor Name',
  })
  @Expose()
  bump1PhaseContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Bump1 Start Date',
  })
  @Expose()
  @Type(() => Date)
  bump1PhaseDateStart!: Date | null;

  @ApiProperty({
    type: 'string',
    title: 'Bump1 Suggested Contractor Name',
  })
  @Expose()
  bump1PhaseSuggestedContractorName!: string;

  //
  // Bump2 Phase fields
  //

  @ApiProperty({
    title: 'Bump2 Contractor Name',
  })
  @Expose()
  bump2PhaseContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Bump2 Start Date',
  })
  @Expose()
  @Type(() => Date)
  bump2PhaseDateStart!: Date | null;

  @ApiProperty({
    title: 'Bump2 Suggested Contractor Name',
  })
  @Expose()
  bump2PhaseSuggestedContractorName!: string | null;

  //
  // Bump3 Phase fields
  //

  @ApiProperty({
    title: 'Bump3 Contractor Name',
  })
  @Expose()
  bump3PhaseContractorName!: string | null;

  @ApiProperty({
    title: 'Bump3 Suggested Contractor Name',
  })
  @Expose()
  bump3PhaseSuggestedContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Bump3 Start Date',
  })
  @Expose()
  @Type(() => Date)
  bump3PhaseDateStart!: Date | null;

  //
  // Bump4 Phase fields
  //

  @ApiProperty({
    title: 'Bump4 Contractor Name',
  })
  @Expose()
  bump4PhaseContractorName!: string | null;

  @ApiProperty({
    title: 'Bump4 Suggested Contractor Name',
  })
  @Expose()
  bump4PhaseSuggestedContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Bump4 Start Date',
  })
  @Expose()
  @Type(() => Date)
  bump4PhaseDateStart!: Date | null;

  //
  // Bump5 Phase fields
  //

  @ApiProperty({
    title: 'Bump5 Contractor Name',
  })
  @Expose()
  bump5PhaseContractorName!: string | null;

  @ApiProperty({
    title: 'Bump5 Suggested Contractor Name',
  })
  @Expose()
  bump5PhaseSuggestedContractorName!: string | null;

  @ApiProperty({
    type: 'date-time',
    title: 'Bump5 Start Date',
  })
  @Expose()
  @Type(() => Date)
  bump5PhaseDateStart!: Date | null;

  //
  // Custom fields
  //

  @ApiProperty({
    title: 'Current phase contractor id',
    nullable: true,
  })
  @Expose()
  currentPhaseContractorId!: string;

  @ApiProperty({
    type: 'string',
    title: 'Suggested Contractor Name',
  })
  @Expose()
  currentPhaseSuggestedContractorName!: string;

  @ApiProperty({
    title: 'Current phase approved status',
  })
  @Expose()
  currentPhaseApproved!: boolean;

  @ApiProperty({
    title: 'Phase request is overdue',
  })
  @Expose()
  currentPhaseRequestIsOnTime!: boolean;

  @ApiProperty({
    title: 'Phase approval is overdue',
  })
  @Expose()
  currentPhaseApprovalIsOnTime!: boolean;

  @ApiProperty({
    type: 'date-time',
    title: 'Current Phase Date Requested',
  })
  @Expose()
  @Type(() => Date)
  currentPhaseDateRequested!: Date | null;

  @ApiProperty({
    title: 'Phase is overdue',
  })
  @Expose()
  currentPhaseIsOnTime!: boolean;

  @ApiProperty({
    title: 'Supervisor Full Names',
  })
  @Expose()
  supervisorFullNames!: string;

  @ApiProperty({
    title: 'Total Payable Boards',
  })
  @Expose()
  totalSquareFootage!: number | null;

  @ApiProperty({
    title: 'PhaseStructureType',
  })
  @Expose()
  phaseStructureType!: string;

  @ApiProperty({
    title: 'PhaseStructureType',
  })
  @Expose()
  currentPhaseContractorName!: string | null;

  @ApiProperty({
    title: ' CurrentPhaseType',
  })
  @Expose()
  currentPhaseType!: PhaseTypeEnum;

  @ApiProperty({
    title: 'createdAt',
  })
  @Expose()
  createdAt!: Date;

  @ApiProperty({
    type: 'date-time',
    title: 'Current Date Approved',
  })
  @Expose()
  @Type(() => Date)
  currentPhaseDateApproved!: Date | null;
}
